import React from 'react'
import { Box } from '@mui/material'
import Txt from './Txt'
import { Category } from '../utils/category'
import { appPrimary } from '../utils/theme'

const sxBanner = {
	bgcolor: appPrimary,
	color: 'white',
	borderRadius: '0.5rem',
	p: '0.75rem 1rem',
	mb: '1rem',
} as const
const sxRow = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	justifyContent: 'space-between',
	gap: '0.5rem',
} as const
const sxText = { flex: 1, minWidth: 0 } as const
const sxDescription = { mt: '0.25rem', color: 'white', opacity: 0.9 } as const

// The banner above a category's product grid: its name and description.
const CategoryHeader = React.memo(({ category }: { category: Category }): JSX.Element => {
	return (
		<Box sx={sxBanner}>
			<Box sx={sxRow}>
				<Box sx={sxText}>
					<Txt variant="h5" fontWeight="bold">
						{category.name}
					</Txt>
					{category.description ? (
						<Txt variant="body2" sx={sxDescription}>
							{category.description}
						</Txt>
					) : null}
				</Box>
			</Box>
		</Box>
	)
})

CategoryHeader.displayName = 'CategoryHeader'

export default CategoryHeader
